import { css } from '@emotion/css';

const styles = {
  contentWrapper: css`
    max-height: none !important;
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
  `,
  titleWrapper: css`
    display: flex;
    align-items: center;
    gap: var(--spacing-200);
  `,
  titleSeparator: css`
    height: 2rem;
    border-left: 1px solid var(--color-border-default);
  `,
  adacLogo: css`
    display: block;
    width: 32px;
    height: auto;
  `,
  body: css`
    gap: var(--spacing-400);
  `,
  benefitIcon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
    margin-inline: auto;
    border-radius: var(--border-radius-rounded);
    background-color: var(--color-background-warning-weak);
    color: var(--color-icon-default);

    svg {
      width: 24px;
      height: 24px;
    }
  `,
  benefitDescription: css`
    color: var(--color-text-weak);
  `,
};

export default styles;
